import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import type { Database } from "@bednbody/types/database";

/**
 * ONE Supabase client factory for every surface. Swaps the auth storage adapter
 * by platform so the same `apps/app` bundle works in-browser (PWA) and wrapped
 * in Capacitor (rider). See vault ARCHITECTURE.md §Code sharing & Capacitor auth.
 *
 * On native, pass the @capacitor/preferences-backed adapter as `storage` so the
 * session survives webview reloads; in-browser it defaults to localStorage.
 */
export function createBednbodyClient(
  url: string,
  anonKey: string,
  storage?: {
    getItem: (k: string) => string | null | Promise<string | null>;
    setItem: (k: string, v: string) => void | Promise<void>;
    removeItem: (k: string) => void | Promise<void>;
  },
): SupabaseClient<Database> {
  return createClient<Database>(url, anonKey, {
    auth: {
      storage: storage ?? (typeof window !== "undefined" ? window.localStorage : undefined),
      persistSession: true,
      detectSessionInUrl: true,
      autoRefreshToken: true,
      // PKCE, not the legacy implicit flow — no tokens riding in the URL
      // fragment. Only matters for redirect-based flows (OAuth); phone OTP
      // and staff email+password are untouched by this.
      flowType: "pkce",
    },
  });
}
